import { render, staticRenderFns } from "./handover_info.vue?vue&type=template&id=189f5698&scoped=true&"
import script from "./handover_info.vue?vue&type=script&lang=js&"
export * from "./handover_info.vue?vue&type=script&lang=js&"
import style0 from "./handover_info.vue?vue&type=style&index=0&id=189f5698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f5698",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContent } from 'vuetify/lib/components/VContent';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContent,VDivider,VRow})
